import { ResponsiveLine } from '@nivo/line';
import { commonHelpers } from 'utilities/helpers';

type props = {
    data: any[];
    legend?: boolean;
    axisLegend?: boolean;
    toolTipText?: {
        x: string;
        y: string;
    };
};

const LineChartComponent = ({ data, legend, axisLegend, toolTipText }: props) => {
    return (
        <ResponsiveLine
            colors={['red', 'blue']}
            data={data}
            xFormat={(e: any) => (e ? commonHelpers.formatInputNumber(e) : '')}
            yFormat={(e: any) => (e ? commonHelpers.formatInputNumber(e) : '')}
            margin={{ top: 50, right: 20, bottom: 50, left: 120 }}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: 'auto',
                max: 'auto',
                stacked: false,
                reverse: false,
            }}
            axisTop={null}
            axisRight={null}
            axisBottom={{
                tickSize: 0,
                tickPadding: 11,
                tickRotation: 0,
                legend: `${axisLegend ? '年数(年)' : ''}`,
                legendOffset: 36,
                legendPosition: 'middle',
            }}
            axisLeft={{
                tickSize: 0,
                tickPadding: 10,
                tickRotation: 0,
                legend: `${axisLegend ? '元金残高(万円)' : ''}`,
                legendOffset: -100,
                legendPosition: 'middle',
                format: (e: any) => `${commonHelpers.formatInputNumber(e)}`,
            }}
            enableGridX={false}
            enablePoints={false}
            pointSize={10}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            useMesh={true}
            legends={
                legend
                    ? [
                          {
                              anchor: 'top',
                              direction: 'row',
                              justify: false,
                              translateX: 0,
                              translateY: -30,
                              itemsSpacing: 0,
                              itemDirection: 'left-to-right',
                              itemWidth: 80,
                              itemHeight: 20,
                              itemOpacity: 0.75,
                              symbolSize: 12,
                              symbolShape: 'circle',
                              symbolBorderColor: 'rgba(0, 0, 0, .5)',
                              effects: [],
                          },
                      ]
                    : []
            }
            tooltip={({ point }) => {
                return (
                    <div
                        style={{
                            background: 'white',
                            padding: '9px 12px',
                            border: '1px solid #ccc',
                            borderRadius: 5,
                        }}
                    >
                        <div>
                            {toolTipText ? toolTipText.x : 'x'}: {point.data.xFormatted}
                        </div>
                        <div>
                            {toolTipText ? toolTipText.y : 'y'}: {point.data.yFormatted}
                        </div>
                    </div>
                );
            }}
        />
    );
};

export default LineChartComponent;
